import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import { Link } from 'react-router-dom';

export default function TermsOfUsePage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '使用條款｜康永生技有限公司',
    description: '康永生技網站使用條款：包含網站用途、智慧財產權、使用限制、免責聲明、洽詢表單使用規範、準據法與管轄等條款說明。',
    keywords: '使用條款,網站條款,康永生技,免責聲明,智慧財產權',
    lang: 'zh-TW',
    canonicalPath: '/terms-of-use',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="使用條款｜康永生技有限公司" pageDescription="康永生技網站使用條款：包含網站用途、智慧財產權、使用限制、免責聲明、洽詢表單使用規範、準據法與管轄等條款說明。" pageUrl={`${siteUrl}/terms-of-use`} />
      <div className="min-h-screen bg-white pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
            <Link to="/" className="hover:text-gray-600 transition-colors cursor-pointer">首頁</Link>
            <i className="ri-arrow-right-s-line text-base" />
            <span className="text-gray-600">使用條款</span>
          </nav>

          {/* Header */}
          <div className="mb-10 pb-8 border-b border-gray-100">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">使用條款</h1>
            <p className="text-gray-400 text-sm">最後更新：2025 年 1 月</p>
          </div>

          {/* Content */}
          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">一、接受條款</h2>
              <p className="text-[0.9375rem]">
                歡迎使用康永生技有限公司（以下簡稱「本公司」）網站。使用本網站即表示您同意遵守本使用條款。
                如您不同意本條款，請勿繼續使用本網站。本公司保留隨時修訂本條款之權利，修訂後的條款自公告時起生效。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">二、網站用途</h2>
              <p className="text-[0.9375rem] mb-3">本網站旨在提供以下資訊與服務：</p>
              <ul className="list-disc list-inside space-y-2 text-[0.9375rem] pl-2">
                <li>康永生技公司簡介、業務範疇及服務項目介紹</li>
                <li>ODM / OEM 代工服務相關資訊</li>
                <li>合作洽詢表單與聯絡功能</li>
                <li>保健食品行業相關知識與法規資訊</li>
              </ul>
              <p className="text-[0.9375rem] mt-3">
                本網站內容僅供商業洽詢與資訊參考使用，不構成法律、醫療或健康建議。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">三、智慧財產權</h2>
              <p className="text-[0.9375rem]">
                本網站所有內容，包括但不限於文字、圖片、圖示、標誌、設計、程式碼及排版，
                均受著作權及其他智慧財產權法律保護，著作權歸屬本公司所有。
                未經本公司書面授權，任何人不得重製、散布、修改、展示或使用本網站內容。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">四、使用限制</h2>
              <p className="text-[0.9375rem] mb-3">使用本網站時，您同意不得：</p>
              <ul className="list-disc list-inside space-y-2 text-[0.9375rem] pl-2">
                <li>以任何方式干擾或破壞本網站的正常運作</li>
                <li>透過本網站發送垃圾郵件或未授權的商業訊息</li>
                <li>以欺詐或不實方式使用本網站的詢問表單</li>
                <li>嘗試未授權存取本網站的系統或資料庫</li>
                <li>抓取、爬蟲或以自動化方式大量擷取本網站內容</li>
                <li>違反任何適用的法律或法規</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">五、資訊準確性</h2>
              <p className="text-[0.9375rem]">
                本公司致力於確保網站資訊的準確性與時效性，但不保證所有資訊均完整、即時或無誤。
                網站內容中的產品規格、服務內容、配方資訊等均僅供參考，實際合作細節以雙方書面合約為準。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">六、免責聲明</h2>
              <p className="text-[0.9375rem]">
                本公司對於因使用本網站所造成的任何直接或間接損失，在法律許可的最大範圍內，不承擔任何責任。
                本網站可能包含第三方網站連結，本公司對第三方網站的內容不負任何責任，
                訪問第三方網站的風險由使用者自行承擔。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">七、洽詢表單使用規範</h2>
              <p className="text-[0.9375rem]">
                使用本網站洽詢表單時，您同意提供的資料真實、準確。
                本公司將依照隱私政策處理您提供的個人資料。
                本公司有權拒絕或忽略任何明顯非善意或不符合業務性質的洽詢。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">八、準據法與管轄</h2>
              <p className="text-[0.9375rem]">
                本使用條款之解釋與適用，以中華民國法律為準據法。
                因本條款或本網站使用所生之一切紛爭，雙方同意以臺灣臺中地方法院為第一審管轄法院。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">九、聯絡我們</h2>
              <p className="text-[0.9375rem]">如對本使用條款有任何疑問，請聯絡我們：</p>
              <div className="mt-4 bg-gray-50 rounded-lg p-5 space-y-2 text-[0.9375rem]">
                <p><strong className="text-gray-900">康永生技有限公司</strong></p>
                <p className="text-gray-600">台中市北區中清路一段79號6樓</p>
                <p>
                  電話：
                  <a href="tel:04-22029858" className="text-[#2d5a27] hover:underline cursor-pointer">(04)-22029858</a>
                </p>
                <p>
                  Email：
                  <a href="mailto:natural1070606@gmail.com" className="text-[#2d5a27] hover:underline cursor-pointer">natural1070606@gmail.com</a>
                </p>
              </div>
            </section>
          </div>

          {/* Related legal links */}
          <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#2d5a27] hover:text-[#1a3d18] text-sm font-medium transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line" />
              返回首頁
            </Link>
            <Link
              to="/privacy-policy"
              className="inline-flex items-center gap-2 text-gray-500 hover:text-[#2d5a27] text-sm transition-colors cursor-pointer"
            >
              <i className="ri-shield-check-line" />
              查看隱私政策
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}